﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import './Layout.css';

import classNames from 'classnames';


export function Expandable(
    {
        loading = false,
        stretched = false,
        expanded = false,
        children
    }
) {

    return (
        <Fragment>
            <div className={classNames("item-expandable", { "stretched": stretched, "expanded": expanded, "bp6-skeleton": loading })}>
                {children}
            </div>
        </Fragment>
    );
}

Expandable.propTypes = {
    loading: PropTypes.bool,
    stretched: PropTypes.bool,
    expanded: PropTypes.bool.isRequired
};